import React, { useEffect, useState } from "react";
import { Calendar, DatePicker, InputNumber } from "antd";
import dayjs from "dayjs";
import {
  CalendarOutlined,
  CloseCircleFilled,
  SwapRightOutlined,
} from "@ant-design/icons";

import ButtonComponent from "components/button-component";
import InputComponent from "components/input-component";
import Text from "components/text";
import styles from "./input.module.css";

const { RangePicker } = DatePicker;

export default function MultiInputsProjectDates({
  onChange,
  errors,
  Data,
  accessLevel,
  saveFlag,
  setIsFieldsDirty,
}) {
  const [inputs, setinputs] = useState(Data);

  useEffect(() => {
    onChange(inputs);
  }, [inputs, onChange]);

  const onIncreaseInput = () => {
    setIsFieldsDirty(true);
    setinputs((prevState) => [
      ...prevState,
      { holidayName: "", startDate: "", finishDate: "" },
    ]);
  };

  const removeinput = (index) => {
    setinputs((prevState) => {
      let newState = [...prevState];
      newState.splice(index, 1);
      return newState;
    });
    setIsFieldsDirty(true);
  };

  const onChangeInput = ({ index, value, fieldName }) => {
    setinputs((prevState) => {
      const newState = [...prevState];
      newState[index][fieldName] = value;
      return newState;
    });
  };

  const onDateRangeChange = (index, dates) => {
    setIsFieldsDirty(true);
    setinputs((prevState) => {
      const newState = [...prevState];
      if (dates && dates.length === 2) {
        newState[index].startDate = dates[0]
          ? dates[0].format("MM-DD-YYYY")
          : "";
        newState[index].finishDate = dates[1]
          ? dates[1].format("MM-DD-YYYY")
          : "";
      } else {
        newState[index].startDate = "";
        newState[index].finishDate = "";
      }
      return newState;
    });
  };

  const getDateRange = (item) => {
    if (item.startDate && item.finishDate) {
      return [dayjs(item.startDate), dayjs(item.finishDate)];
    }
    return null;
  };

  return (
    <div>
      <div className="row">
        <div className="col-4 my-2">
          <Text className=" fs-6 fw-bold">Name</Text>
        </div>
        <div className="col-6 my-2 d-flex align-items-center">
          <Text className=" fs-6 fw-bold">Date</Text>
        </div>
      </div>
      {inputs?.map((item, index) => (
        <div key={index + ""} className="row d-flex align-items-center">
          <div className="col-4">
            <InputComponent
              value={item?.holidayName}
              onChange={(value) =>
                onChangeInput({
                  index,
                  fieldName: "holidayName",
                  value,
                })
              }
            />
          </div>
          <div
            className="col-6 my-1 border border-1 rounded-2"
            style={{ maxWidth: "280px", minWidth: "280px" }}
          >
            <RangePicker
              value={getDateRange(item)}
              onChange={(dates) => onDateRangeChange(index, dates)}
              format="MM-DD-YYYY"
              style={{ width: "40%" }}
              bordered={false}
              placeholder={["Start Date", "End Date"]}
              // allowClear={true}
              allowClear={{
                clearIcon: (
                  <span
                    style={{
                      position: "absolute",
                      right: "-150px",
                      top: "-5px",
                    }}
                  >
                    <CloseCircleFilled />
                  </span>
                ),
              }}
              suffixIcon={false}
              separator={<span style={{ margin: "0px 0px 0px -5px" }}>-</span>}
              className={`${styles.customRangePicker}`}
            />
          </div>
          {index === inputs?.length - 1 ? (
            <>
              <div className="col-md-1 mt-1 ">
                <ButtonComponent
                  disabled={saveFlag && accessLevel > 1 ? false : true}
                  title="+"
                  onClickAction={onIncreaseInput}
                />
              </div>
            </>
          ) : (
            <>
              <div className="col-md-1 mt-1 opacity-0 ">
                <ButtonComponent
                  disabled
                  title="+"
                  style={{ cursor: "default" }}
                />
              </div>
            </>
          )}
          {inputs.length !== 1 && (
            <div className="col-1 mt-1 ">
              <ButtonComponent
                type="button"
                title="-"
                onClickAction={() => removeinput(index)}
                className={"bg-danger"}
                disabled={accessLevel <= 2 ? true : false}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
